import script from "./updateLog.vue?vue&type=script&setup=true&lang=js"
export * from "./updateLog.vue?vue&type=script&setup=true&lang=js"

import "./updateLog.vue?vue&type=style&index=0&id=927e7676&lang=css"

const __exports__ = script;

export default __exports__